var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Payments_-_fill",
    "data-name": "Payments - fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.091,
    viewBox: "0 0 18 13.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M19,10.545v1.636c0,2.711-4.03,4.909-9,4.909-4.882,0-8.856-2.12-9-4.764l0-.145V10.545c0,2.711,4.03,4.909,9,4.909S19,13.257,19,10.545ZM10,4c4.97,0,9,2.2,9,4.909s-4.03,4.909-9,4.909-9-2.2-9-4.909S5.03,4,10,4Z",
    transform: "translate(-1 -4)",
    fill: "#002d44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentfill);
export default __webpack_public_path__ + "static/media/paymentfill.a63344313fbe1cbce27ea67d879971e9.svg";
export { ForwardRef as ReactComponent };